<template>
  <div class="ticket_way_container">
    <div class="container text-center color-ccc fs-30 empty-tip " v-if="_i18n.locale==='zh'">{{ $t('public.ticketTips') }}</div>
    <!-- <div class="container text-center color-ccc fs-30 empty-tip ">Please Follow "广州国际汽车展" WeChat Official Account To Ticketing. -->
 <!-- </div> -->
    <div class="container fs-30 flex_wrap bold" v-if="_i18n.locale==='en'">
      <span>A. Overseas Audience (E-ticket)</span>
      <span>Ticket Purchase Process for E-ticket (for users with WeChat) :</span>
    </div>
    <span class="container fs-20 step_tips" v-if="_i18n.locale==='en'">Step 1. Access the "Guangzhou International Automobile Exhibition" WeChat mini program.</span>
    <img src="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/pubImg.png" alt=""/>
    <div class="container fs-20 flex_wrap" v-if="_i18n.locale==='en'">
      <span>Step 2. Select and purchase the ticket type as needed.</span>
      <span>Step 3. Follow the instructions to upload your passport information for real-name authentication.</span>
      <span>Step 4. After successful payment, scan your electronic QR code at the gate to enter the venue.</span>
    </div>
    <div class="container fs-30  flex_wrap bold mt-30" v-if="_i18n.locale==='en'">
      <span>B. Overseas Audience (Physical Ticket)</span>
      <span>Ticket Purchase Process for Physical Ticket (for users without WeChat):</span>
    </div>
    <span class="container fs-20 step_tips" v-if="_i18n.locale==='en'">Step 1. Follow the on-site signs or seeking staffs for assistance to purchase tickets on-site.</span>
    <img style="width: 80%;" src="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/sp.jpg" v-if="_i18n.locale==='en'" alt=""/>
    <div class="container fs-20 flex_wrap" v-if="_i18n.locale==='en'">
      <span>Step 2. After purchasing the ticket, the staff will assist you in completing the real-name verification process by matching the ticket code with your personal identification information</span>
      <span>Step 3. Once the real-name authentication is completed, staff will assist you in scanning the code to enter the venue.</span>
    </div>
      <!-- <el-table
      :data="ticketList"
      border
      style="width: 100%;"
      header-cell-class-name="header-row"
      :cell-style="{textAlign: 'center'}"
    >
      <el-table-column prop="types" label="类型"></el-table-column>
      <el-table-column prop="fees" label="票价"></el-table-column>
      <el-table-column prop="dates" label="有效日期"></el-table-column>
      <el-table-column prop="tips" label="说明"></el-table-column>
    </el-table> -->
  </div>
</template>

<script>
export default {
    data(){
        return{
            ticketList:[
                {
                    types:"专业观众票",
                    fees:"100元",
                    dates:"12月31日-1月8日",
                    tips:"有效日期内任选一日进场参观，一次进场有效"
                },
                {
                    types:"普通观众票",
                    fees:"50元",
                    dates:"1月2日-1月8日",
                    tips:"有效日期内任选一日进场参观，一次进场有效"
                }
            ]
        }
    }
}
</script>

<style lang="scss">
.ticket_way_container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    >img{
        width: 30%;
        margin-top: 30px;
    }
    >div{
      line-height: 50px;
    }
}
.flex_wrap{
  display: flex;
  flex-direction: column;
}
.step_tips{
  line-height: 50px;
}


@media screen and (max-width: 1000px) {
  .ticket_way_container {
    width: 100vw;
  }
}
</style>


// WEBPACK FOOTER //
// ticketWay.vue?c40d07ea